export default "__VITE_ASSET__DGPB42HE__"